import { f as a } from "./addOns-5IZhcbHD.js";
const o = {
  id: "FloridaPick4",
  name: "Pick 4",
  style: {
    colorPrimary: "#1e988a",
    fireball: a
  }
};
export {
  o as default
};
